import React from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';

const NewsCardWrapper = styled.div`
  border: 1px solid #000;
  padding: 24px;
  width: 300px;
  cursor: pointer;
  transition: transform 0.3s ease;
  display: flex;
  gap: 16px;

  &:hover {
    transform: translateY(-2px);
  }
`;

const TextSection = styled.div`
  flex: 1;
  min-width: 0;
`;

const Date = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 12px;
  font-weight: 400;
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 12px 0;
  line-height: 1.4;
`;

const Content = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => (props.$expanded ? 'unset' : '3')};

  p {
    margin: 0;
  }
`;

const ImageSection = styled.div`
  width: 100px;
  flex-shrink: 0;
  position: relative;
`;

const ImageStack = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
`;

const StackedImage = styled.img`
  position: absolute;
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 1px solid #000;
  transition: transform 0.3s ease;
  transform: rotate(${({ $index }) => $index * 5}deg);

  &:hover {
    transform: scale(1.05) rotate(0deg);
    z-index: 2;
  }
`;

const NewsCard = ({ news, onOpenModal }) => {
  const handleCardClick = () => {
    onOpenModal(news);
  };

  return (
    <NewsCardWrapper onClick={handleCardClick}>
      <TextSection>
        <Date>{news.date}</Date>
        <Title>{news.title}</Title>
        <Content>
          <ReactMarkdown>{news.content}</ReactMarkdown>
        </Content>
      </TextSection>
      {news.images && news.images.length > 0 && (
        <ImageSection>
          <ImageStack>
            {news.images.slice(0, 3).map((img, index) => (
              <StackedImage
                key={index}
                src={img.image}
                alt={`News image ${index + 1}`}
                $index={index}
              />
            ))}
          </ImageStack>
        </ImageSection>
      )}
    </NewsCardWrapper>
  );
};

export default NewsCard;
